import { useTranslation } from 'react-i18next';
import { Droplets, Sparkles, Shirt, Truck } from 'lucide-react';
import { GoldThread } from '@/components/brand/GoldThread';

export default function ServicesPage() {
  const { t } = useTranslation();

  const services = [
    { num: '01', icon: <Droplets size={28} />, title: t('services.wash_title'),     body: t('services.wash_body') },
    { num: '02', icon: <Sparkles size={28} />, title: t('services.dry_title'),      body: t('services.dry_body') },
    { num: '03', icon: <Shirt size={28} />,    title: t('services.delicate_title'), body: t('services.delicate_body') },
    { num: '04', icon: <Truck size={28} />,    title: t('services.pickup_title'),   body: t('services.pickup_body') },
  ];

  return (
    <>
      {/* Title */}
      <section className="bg-bone">
        <div className="container pt-20 pb-16 md:pt-32 md:pb-20">
          <div className="grid grid-cols-12 gap-y-10 gap-x-6">
            <div className="col-span-12 md:col-span-9 animate-fade-up">
              <div className="flex items-center gap-4 mb-6">
                <GoldThread />
                <span className="eyebrow">{t('nav.services')}</span>
              </div>
              <h1 className="font-display text-d-2 text-ink"
                  style={{ fontVariationSettings: "'opsz' 144, 'wght' 500" }}>
                {t('services.title')}
              </h1>
              <p className="mt-8 max-w-2xl font-body text-lg md:text-xl text-charcoal leading-relaxed">
                {t('services.lead')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Detail blocks — alternating layout */}
      <section className="container pb-24 md:pb-32">
        <div className="space-y-20 md:space-y-32">
          {services.map((svc, i) => (
            <div key={svc.num} className="grid grid-cols-12 gap-y-8 gap-x-6 items-start">
              <div className={`col-span-12 md:col-span-1 ${i % 2 === 1 ? 'md:order-2' : ''}`}>
                <span className="font-display text-gold text-3xl"
                      style={{ fontVariationSettings: "'opsz' 144, 'wght' 400" }}>
                  {svc.num}
                </span>
              </div>
              <div className={`col-span-12 md:col-span-1 text-gold ${i % 2 === 1 ? 'md:order-1 md:text-end' : ''}`}>
                {svc.icon}
              </div>
              <div className={`col-span-12 md:col-span-9 ${i % 2 === 1 ? 'md:order-3' : ''}`}>
                <h2 className="font-display text-3xl md:text-5xl text-ink"
                    style={{ fontVariationSettings: "'opsz' 90, 'wght' 500" }}>
                  {svc.title}
                </h2>
                <p className="mt-5 max-w-2xl font-body text-base md:text-lg text-charcoal leading-relaxed">
                  {svc.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
